import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useTracking } from '@justgiving/react-tracking';

import { PageStatus } from '../../../types/__generated__';
import classNames from 'classnames';
import styles from './CampaignStartFundraising.scss';
import { filterByTypename } from '../../utils/graphql';
import { useBasePageQuery } from '../../hooks';

const CampaignStartFundraising: FunctionComponent = () => {
  const basePageData = useBasePageQuery();

  const track = useTracking();
  const { t } = useTranslation('common', { useSuspense: false });

  const { startFundraisingUrl, status, relationships } =
    basePageData?.data?.page ?? {};

  const beneficiaries = relationships?.beneficiaries;
  const membersDisabled = relationships?.config?.membersDisabled;

  if (
    !beneficiaries ||
    beneficiaries.nodes.length === 0 ||
    membersDisabled ||
    !startFundraisingUrl
  ) {
    return null;
  }
  const charities = filterByTypename(beneficiaries.nodes, 'Charity');

  return (
    <section className={classNames(styles.container)}>
      <h2 className="jg-h4">{t('campaign.startFundraisingTitle')}</h2>
      {status === PageStatus.Completed && (
        <>
          <p>{t('campaign.startFundraisingCompleted')}</p>
          <a
            className={classNames('jg-btn', 'jg-btn--ghost')}
            href={`${charities[0].profilePageUrl}`}
            onClick={() => {
              track({
                event: 'link click',
                subtype: 'button',
                event_value: 'view charity profile',
                page_section: 'become a fundraiser',
              });
            }}
          >
            {t('campaign.startFundraisingCompletedCTA')}
          </a>
        </>
      )}

      {status !== PageStatus.Completed && (
        <>
          <p>{t('campaign.startFundraising')}</p>
          <a
            className={classNames('jg-btn', 'jg-btn--primary')}
            href={startFundraisingUrl}
            onClick={() => {
              track({
                event: 'link click',
                subtype: 'button',
                event_value: 'start fundraising',
                page_section: 'become a fundraiser',
              });
            }}
          >
            {t('campaign.startFundraisingCTA')}
          </a>
        </>
      )}
    </section>
  );
};

export default CampaignStartFundraising;
